import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPhoneOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" {...props}>
    <path
      d="M8 3H.5M6 0l2 3-2 3M18.23.838c.497.443.809.722.936.837.707.629.82 1.519.342 2.67-.718 1.726-3.41 5.889-9.272 9.407-1.294.91-2.456.705-2.99 0a72.88 72.88 0 0 0-1.046-1.35c-.38-.586-.22-1.13.48-1.632 1.048-.753.713-.487 1.57-1.075.857-.587.85-.456 1.986 0 1.136.456 1.147.854 2.273-.22a83.9 83.9 0 0 0 2.885-2.938c.44-.413.44-.929 0-1.547-.66-.927-.66-1.283 0-2.3A19.55 19.55 0 0 1 16.752.838c.49-.443.982-.443 1.478 0z"
      fill="none"
      stroke="#007AFF"
    />
  </svg>
);
const Memo = memo(SvgPhoneOpen);
export default Memo;
